import { Page } from '@/core/architecture'

import { FirstComeFirstServedCompleteTemplate } from './template'
import { useViewModel } from './viewModel'

/**
 * FirstComeFirstServedComplete Page
 * Implemented as a practical sample.
 */
export const FirstComeFirstServedComplete: Page = () => {
  const { state, actions } = useViewModel()

  return <FirstComeFirstServedCompleteTemplate state={state} {...actions} />
}
